<template>
  <div class="container">

<baseFrame
  :showCtrls='true'
  submitText='更新'
  @submit='update'
  clearText=''

>
      <lk-form slot='content'
               :label-width='140'
               label-position="right"
               class="supplierUpdate"

      >

     <div class="cardContainer"  v-for="(card,cardIndex) in cards" :key="cardIndex" v-show='card.items.length'>
       <lk-card :title="card.title">
         <lk-row :gutter='16'>
           <lk-col :span='10'>
             <lk-form-item>
               <span>旧值</span>
             </lk-form-item>
           </lk-col>
           <lk-col :span='10' :offset='2'>
             <lk-form-item >
               <span>新值</span>
             </lk-form-item>
           </lk-col>
         </lk-row>
         <lk-row :gutter='16' v-for="(item,index) in card.items" :key="index">
           <lk-col :span='10'>
             <lk-form-item :label='item.oldObj.name+":"'>
               <Uploader v-if="item.oldObj.isPic" v-model="item.oldObj.value"></Uploader>
               <span v-else>{{item.oldObj.value}}</span>
             </lk-form-item>
           </lk-col>
           <lk-col :span='10' :offset='2'>
             <lk-form-item :label='item.newObj.name+":"'>
               <span v-if="item.newObj.isPic"  :class="{'ischange':item.newObj.value!==item.oldObj.value}">

               <Uploader  v-model="item.newObj.value"></Uploader>
               </span>
               <span :class="{'ischange':item.newObj.value!==item.oldObj.value}" v-else>{{item.newObj.value}}</span>

             </lk-form-item>
           </lk-col>
         </lk-row>
       </lk-card>
     </div>
     <!-- <div class="cardContainer" v-if="supplierCeritificateInfo.length">
       <lk-card title="证件信息">
         <lk-row :gutter='16'>
           <lk-col :span='10'>
             <lk-form-item >
               <span>旧值</span>
             </lk-form-item>
           </lk-col>
           <lk-col :span='10' :offset='2'>
             <lk-form-item >
               <span>新值</span>
             </lk-form-item>
           </lk-col>
         </lk-row>

         <lk-row :gutter='16' v-for="(item,index) in supplierCeritificateInfo" :key="index" >
           <lk-col :span='10'>
             <lk-form-item :label='item.oldObj.name+":"'>
               <Uploader v-if="item.oldObj.isPic" v-model="item.oldObj.value"></Uploader>
               <span v-else>{{item.oldObj.value}}</span>
             </lk-form-item>
           </lk-col>
           <lk-col :span='10' :offset='2'>
             <lk-form-item :label='item.newObj.name+":"'>
               <span v-if="item.newObj.isPic"  :class="{'ischange':item.newObj.value!==item.oldObj.value}">

               <Uploader  v-model="item.newObj.value"></Uploader>
               </span>
               <span :class="{'ischange':item.newObj.value!==item.oldObj.value}" v-else>{{item.newObj.value}}</span>

             </lk-form-item>
           </lk-col>
         </lk-row>
       </lk-card>
     </div> -->
      </lk-form>
</baseFrame>


  </div>
</template>

<script>


// import Axios from '@/services/axios';
import baseFrame from '@/components/frame/BaseFrame.vue';
import Uploader from '../../../components/Uploader.vue';
import utils from '../../../libs/utils';
import supplier from '../../../services/supplier';
// import goods from '../../../services/goods';

export default {
  name: 'SupplierStorestoreInfo',
  components: {
    baseFrame,
    Uploader,
  },


  data() {
    return {
      cards: [],
      // infosArr: [],
      // supplierBaseInfo: [],
      // supplierCeritificateInfo: [],
      // businessScope: [],
      // productScope: [],
      cardsNames: {
        supplierInfo: '供应商信息',
        drugProdInfo: '药品生产信息',
        drugBizInfo: '药品经营信息',
        equipmentProdInfo: '器械生产信息',
        equipmentBizInfo: '器械经营信息',
        foodInfo: '食品信息',
        cosmeticInfo: '化妆品信息',
        otherInfo: '其他证件',
      },
    };
  },
  computed: {

  },
  methods: {
    update() {
      supplier.supplierUpdate({ id: this.$route.query.generalInfoId }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('更新成功');
          this.$router.go(-1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // getBusinessScope() {
    //   return new Promise((resolve) => {
    //     supplier.supplierScope().then((res) => {
    //       if (res.data.status === 200) {
    //         this.businessScope = res.data.data[0].supplierBusinessLabelVoList;
    //         resolve();
    //       } else {
    //         this.$Message.error(res.data.error);
    //       }
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    //   });
    // },
    // getProductScope() {
    //   return new Promise((resolve) => {
    //     goods.GoodsDictionary({ dictionaryTypeEnum: 13 }).then((res) => {
    //       if (res.data.status === 200) {
    //         this.productScope = [];
    //
    //         res.data.data.forEach((item) => {
    //           const productItem = {
    //             name: item.dictionaryName,
    //             id: item.id,
    //             // disabled: !this.able,
    //
    //           };
    //           // this.businessScopeTree.push(businessItem);
    //
    //           this.productScope.push(productItem);
    //         });
    //         resolve();
    //       } else {
    //         this.$Message.error(res.data.error);
    //       }
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    //   });
    // },
    getInfos() {
      supplier.supplierUpdateInfo({
        generalInfoId: this.$route.query.generalInfoId,
        storeInfoId: this.$route.query.storeInfoId,
      }).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          const { data } = res.data;
          // this.supplierBaseInfo = res.data.data.supplierBaseInfo;
          let index = 0;
          for (const key in data) {
            this.$set(this.cards, index, {
              title: this.cardsNames[key],
              items: [],
            });


            for (let i = 0; i < data[key].length; i++) {
              // const element = array[i];
              const item = utils.deepClone(data[key][i]);

              if (item.newObj.type === 2) {
                item.newObj.isPic = true;
                item.oldObj.isPic = true;
              }
              // this.cards[index].items.push(item);
              this.$set(this.cards[index].items, i, item);
            }

            // data[key].map((element) => {
            //   const item = utils.deepClone(element);
            //   if (item.newObj.type === 2) {
            //     item.newObj.isPic = true;
            //     item.oldObj.isPic = true;
            //   }
            //   this.cards[index].items.push(item);
            // });
            index += 1;
          }
          console.log(this.cards);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

  },

  created() {
    // this.workNo = this.approvalParams.workNo;
    // this.node = this.approvalParams.node;
    // this.moduleName = this.approvalParams.moduleName;
  //   Promise.all([this.getProductScope(), // this.getBusinessScope(),
  //   ])
  //     .then(() => {
  //       });
    this.getInfos();
  },
};
</script>

<style lang='less' scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .demo-auto-complete-item{
    width: 650px
  }
  .searchItem{
    display: inline-block;
    width: 25%;
  }
  .noThing{
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    color: rgba(0, 0, 0, 0.25)
  }
  .record{
  font-size: 14px;
  padding: 0 10px;
  line-height: 2
}
.records{
  max-height: 60vh;
  overflow: auto
}
.ischange{
  color: #ed4014;
  >*{
    // border:1px solid #ed4014;
    // // height: 82px;
    // height: 32px;
  }
}
</style>
